import { Button, Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { Calendar } from "../../icons/Calendar";
import styles from "./styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setTopFilters } from "../../store/slices/dashboardSlice";

const formatDateToUTC = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone: "UTC",
    }).format(date);
};

const adjustToUTC = (date, isEndOfDay = false) => {
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    if (isEndOfDay) {
        utcDate.setUTCHours(23, 59, 59, 999);
    } else {
        utcDate.setUTCHours(0, 0, 0, 0);
    }
    return date;
};
const adjustToUTC2 = (date, isEndOfDay = false) => {
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() );
    if (isEndOfDay) {
        utcDate.setUTCHours(23, 59, 59, 999);
    } else {
        utcDate.setUTCHours(0, 0, 0, 0);
    }
    return utcDate;
};
const DatePicker = ({
                        filter,
                        setFilters,
                        name,
                        selectedDateField,
                        horisontal = false,
                        removeFilter,
                        topFilter = false,
                    }) => {

    const [isOpenModal, setIsOpenModal] = useState(false);
    const [selectionRange, setSelectionRange] = useState({
        startDate: filter?.minimum
            ? adjustToUTC(new Date(filter?.minimum))
            : adjustToUTC(new Date(selectedDateField?.minimum)),
        endDate: filter?.maximum
            ? adjustToUTC(new Date(filter?.maximum), true)
            : adjustToUTC(new Date(selectedDateField?.maximum), true),
    });
    const [selectedPreset, setSelectedPreset] = useState(null); // Track selected preset
    const dispatch = useDispatch();
    const { id } = useParams();
    const { topFilters } = useSelector((state) => {
        return state.dashboard[id] || {};
    });
    const presetRanges = [
        { label: "Today", range: { startDate: adjustToUTC(new Date()), endDate: adjustToUTC(new Date(), true) } },
        {
            label: "Yesterday",
            range: {
                startDate: adjustToUTC(new Date(Date.now() - 86400000)),
                endDate: adjustToUTC(new Date(Date.now() - 86400000), true),
            },
        },
        {
            label: "This week",
            range: {
                startDate: adjustToUTC(new Date(Date.now() - new Date().getDay() * 86400000)),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "Last week",
            range: {
                startDate: adjustToUTC(new Date(Date.now() - (new Date().getDay() + 7) * 86400000)),
                endDate: adjustToUTC(new Date(Date.now() - new Date().getDay() * 86400000), true),
            },
        },
        {
            label: "This month",
            range: {
                startDate: adjustToUTC(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "Last month",
            range: {
                startDate: adjustToUTC(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)),
                endDate: adjustToUTC(new Date(new Date().getFullYear(), new Date().getMonth(), 0), true),
            },
        },
        {
            label: "Last 90 days",
            range: {
                startDate: adjustToUTC(new Date(Date.now() - 90 * 86400000)),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "This year",
            range: {
                startDate: adjustToUTC(new Date(new Date().getFullYear(), 0, 1)),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "Last year",
            range: {
                startDate: adjustToUTC(new Date(new Date().getFullYear() - 1, 0, 1)),
                endDate: adjustToUTC(new Date(new Date().getFullYear() - 1, 11, 31), true),
            },
        },
        { label: "All the time",
            range: {
                startDate: adjustToUTC(new Date(selectedDateField?.minimum)),
                endDate: adjustToUTC(new Date(selectedDateField?.maximum), true),
            },
        },
    ];

    useEffect(() => {
        if (filter) {
            setSelectionRange({
                startDate: adjustToUTC(new Date(filter?.minimum)),
                endDate: adjustToUTC(new Date(filter?.maximum), true),
            });
        }
    }, [filter]);

    const handleSelect = useCallback((ranges) => {
        const { startDate, endDate } = ranges.selection;
        setSelectionRange({
            startDate: adjustToUTC(startDate),
            endDate: adjustToUTC(endDate, true),
        });
        setSelectedPreset(null); // Clear selected preset when a custom date is picked
    }, []);

    const handleSubmit = () => {
        let minimum = selectionRange.startDate.toISOString();
            minimum = adjustToUTC2(selectionRange.startDate)
        let maximum = selectionRange.endDate.toISOString();
        maximum= adjustToUTC2(selectionRange.endDate,true)
        console.log(maximum);
        const newFilter = { name, minimum, maximum };
        if (topFilter) {
            dispatch(setTopFilters({
                id,
                filters: (topFilters || []).filter((filter) => filter.name !== name).concat(newFilter),
            }));
        } else {
            setFilters((prevFilters) => {
                const index = prevFilters.findIndex((f) => f.name === name);
                if (index !== -1) {
                    const updatedFilters = [...prevFilters];
                    updatedFilters[index] = { ...updatedFilters[index], minimum, maximum };
                    return updatedFilters;
                } else {
                    return [...prevFilters, { name, minimum, maximum }];
                }
            });
        }
    };

    const showModal = () => {
        setIsOpenModal(true);
    };

    const handleOk = () => {
        handleSubmit();
        setIsOpenModal(false);
    };

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleRemove = () => {
        if (topFilter) {
            removeFilter(filter?.name);
            dispatch(setTopFilters({
                id,
                filters: (topFilters || []).filter((existingFilter) => existingFilter.name !== name), // Remove only the filter matching `name`
            }));
            handleClose();
        } else {
            setFilters((prevFilters) =>
                prevFilters.filter((el) => el.name !== filter?.name),
            );
            handleClose();
        }
    };

    const applyPreset = (presetRange, presetLabel) => {
        setSelectionRange(presetRange);
        setSelectedPreset(presetLabel); // Mark the selected preset
    };

    return (
        <div>
            <div className={`${styles.calendarBtns} ${horisontal ? styles.calendarBtnsHorisontal : ""}`}>
                <Button type="default" className={styles.calendarBtn} onClick={showModal}>
                    {filter?.minimum ? formatDateToUTC(filter.minimum) : "Any time"}
                    <Calendar />
                </Button>
                {horisontal && "-"}
                <span className={styles.divider}>to</span>
                <Button type="default" className={styles.calendarBtn} onClick={showModal}>
                    {filter?.maximum ? formatDateToUTC(filter.maximum) : "Any time"}
                    <Calendar />
                </Button>
            </div>
            <Modal title="Select date range"
                   open={isOpenModal}
                   okText="Save"
                   onOk={handleOk}
                   onCancel={handleClose}
                   className={styles.modal}
                   okButtonProps={{ style: { backgroundColor: "black", borderColor: "black", color: "white" } }}
            >
                <div className={styles.modalContent}>
                    <div className={styles.modalHeader}>
                        <div className={styles.modalHeaderText}>
                            {`From ${formatDateToUTC(selectionRange?.startDate)} to ${formatDateToUTC(selectionRange?.endDate)}`}
                        </div>
                        <button className={styles.removeBtn} onClick={handleRemove}>
                            Clear range
                        </button>
                    </div>

                    <div className={styles.modalBody}>
                        <div className={styles.presetSidebar}>
                            {presetRanges.map((preset) => (
                                <button
                                    key={preset.label}
                                    onClick={() => applyPreset(preset.range, preset.label)}
                                    className={selectedPreset === preset.label ? styles.activePreset : ""}
                                >
                                    {preset.label}
                                </button>
                            ))}
                        </div>
                        <DateRangePicker
                            showDateDisplay={false}
                            showSelectionPreview={false}
                            ranges={[{
                                startDate: selectionRange.startDate,
                                endDate: selectionRange.endDate,
                                key: "selection",
                            }]}
                            onChange={handleSelect}
                            months={2}
                            direction="horizontal"
                            preventSnapRefocus={true}
                            calendarFocus="forwards"
                            minDate={adjustToUTC(new Date(selectedDateField?.minimum))}
                            maxDate={adjustToUTC(new Date(selectedDateField?.maximum), true)}
                            rangeColors={["#000000"]}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default DatePicker;
